module.exports = __webpack_public_path__ + "f6cfb416a30e25cafe2c914ec56f2197.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/building.png
 ** module id = 1562
 ** module chunks = 0
 **/